"use strict";
exports.__esModule = true;
var utils_1 = require("./utils");
var Environment;
(function (Environment) {
    Environment["demo"] = "demo";
    Environment["stageDev"] = "stageDev";
    Environment["integrationDev"] = "integrationDev";
    Environment["production"] = "production";
    Environment["development"] = "development";
    Environment["stage"] = "stage";
    Environment["integration"] = "integration";
})(Environment = exports.Environment || (exports.Environment = {}));
var Components;
(function (Components) {
    Components["text"] = "textbox";
    Components["image"] = "image";
    Components["fabric"] = "fabric";
    Components["irs"] = "irs";
    Components["productview"] = "productview";
    Components["price"] = "price";
    Components["custom"] = "custom";
    Components["productOptions"] = "productOptions";
    Components["zoom"] = "zoom";
    Components["addToCart"] = "addToCart";
})(Components = exports.Components || (exports.Components = {}));
var DefaultComponentContainers;
(function (DefaultComponentContainers) {
    DefaultComponentContainers["textbox"] = "artifi-textbox";
    DefaultComponentContainers["image"] = "artifi-image";
    DefaultComponentContainers["fabric"] = "artifi-fabric";
    DefaultComponentContainers["irs"] = "artifi-irs";
    DefaultComponentContainers["productview"] = "artifi-product-views";
    DefaultComponentContainers["price"] = "artifi-price";
    DefaultComponentContainers["custom"] = "artifi-custom";
    DefaultComponentContainers["productOptions"] = "artifi-product-options";
    DefaultComponentContainers["zoom"] = "artifi-zoom";
    DefaultComponentContainers["addToCart"] = "artifi-add-to-cart";
})(DefaultComponentContainers = exports.DefaultComponentContainers || (exports.DefaultComponentContainers = {}));
exports.CDNServer = utils_1.getEnvironmentCDNPath(process.env.CLIENT);
var ExternalScripts;
(function (ExternalScripts) {
    ExternalScripts["redux"] = "https://unpkg.com/redux@4.0.5/dist/redux.js";
    ExternalScripts["react"] = "https://unpkg.com/react@16/umd/react.development.js";
    ExternalScripts["reactDom"] = "https://unpkg.com/react-dom@16/umd/react-dom.development.js";
    ExternalScripts["reactRedux"] = "https://cdnjs.cloudflare.com/ajax/libs/react-redux/7.2.0/react-redux.min.js";
})(ExternalScripts = exports.ExternalScripts || (exports.ExternalScripts = {}));
// NOTE: redux-dynamic-modules/core/thunk didn't have any CDN right now.
var ArtifiScripts;
(function (ArtifiScripts) {
    ArtifiScripts["reduxDynamicModule"] = "core/scripts/dev/redux-dynamic-modules";
    ArtifiScripts["reduxDynamicModuleCore"] = "core/scripts/dev/redux-dynamic-modules-core";
    ArtifiScripts["reduxDynamicModuleThunk"] = "core/scripts/dev/redux-dynamic-modules-thunk";
    ArtifiScripts["artifiCore"] = "core/dist/artifi";
})(ArtifiScripts = exports.ArtifiScripts || (exports.ArtifiScripts = {}));
var ArtifiComponents;
(function (ArtifiComponents) {
    ArtifiComponents["textbox"] = "textbox/dist/artifi-textbox";
    ArtifiComponents["image"] = "graphics/dist/artifi-graphics";
    ArtifiComponents["fabric"] = "fabric-renderer/dist/artifi-fabric";
    ArtifiComponents["irs"] = "irs-renderer/dist/artifi-irs";
    ArtifiComponents["productview"] = "product-views/dist/artifi-product-views";
    ArtifiComponents["price"] = "price/dist/artifi-price";
    ArtifiComponents["custom"] = "#";
    ArtifiComponents["productOptions"] = "product-options/dist/artifi-product-options";
    ArtifiComponents["zoom"] = "zoom/dist/artifi-zoom";
    ArtifiComponents["addToCart"] = "add-to-cart/dist/artifi-add-to-cart";
})(ArtifiComponents = exports.ArtifiComponents || (exports.ArtifiComponents = {}));
/* WindowEvents are just for outside events for parent application */
var WindowEvents;
(function (WindowEvents) {
    WindowEvents["INIT_START"] = "artifi-component-init-start";
    WindowEvents["INIT_DONE"] = "artifi-component-init-done";
})(WindowEvents = exports.WindowEvents || (exports.WindowEvents = {}));
